// extracted by mini-css-extract-plugin
export default {"App":"Upload_App__mfDcU","root":"Upload_root__7FCgJ","container":"Upload_container__yHxLG","dropzone":"Upload_dropzone__m+UKN"};